"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityVerbs = exports.activityChangeTypes = exports.activityChangeType = void 0;
const activityVerbs = exports.activityVerbs = {
  ISSUE_CREATE: "quality-issue-create",
  ISSUE_OPEN: "quality-issue-open",
  ISSUE_DRAFT: "quality-issue-draft",
  ISSUE_IN_PROGRESS: "quality-issue-in-progress",
  ISSUE_COMPLETED: "quality-issue-completed",
  ISSUE_NOT_APPROVED: "quality-issue-not-approved",
  ISSUE_IN_DISPUTE: "quality-issue-in-dispute",
  ISSUE_CLOSED: "quality-issue-closed",
  ISSUE_PENDING: "quality-issue-pending",
  ISSUE_IN_REVIEW: "quality-issue-in-review",
  ISSUE_EDIT: "quality-issue-edit",
  ISSUE_DUE_DATE: "quality-issue-due-date",
  ISSUE_ASSIGN: "quality-issue-assign",
  ISSUE_COMMENT: "quality-issue-comment",
  ISSUE_REFERENCE_ADDED: "issue-link-added",
  ISSUE_REFERENCE_REMOVED: "issue-link-removed",
  ISSUE_PLACEMENT_ADD: "issue-placement-add",
  ISSUE_PLACEMENT_REPOSITION: "issue-placement-reposition",
  ISSUE_PLACEMENT_REMOVE: "issue-placement-remove",
  ISSUE_DELETED: "quality-issue-deleted",
  ISSUE_RESTORED: "quality-issue-restored",
  ISSUE_SNAPSHOT_EDIT: "issue-snapshot-edit",
  ISSUE_ATTACHMENT_ADD: "issue-attachment-add",
  ISSUE_ATTACHMENT_REMOVE: "issue-attachment-remove"
};
let activityChangeType = exports.activityChangeType = /*#__PURE__*/function (activityChangeType) {
  activityChangeType["ChangedTitle"] = "changed_title";
  activityChangeType["ChangedPublished"] = "changed_published";
  activityChangeType["ChangedStatus"] = "changed_status";
  activityChangeType["ChangedIssueType"] = "changed_issue_type_id";
  activityChangeType["ChangedIssueSubtype"] = "changed_issue_subtype_id";
  activityChangeType["ChangedDescription"] = "changed_description";
  activityChangeType["ChangedAssignedTo"] = "changed_assigned_to";
  activityChangeType["ChangedStartDate"] = "changed_start_date";
  activityChangeType["ChangedDueDate"] = "changed_due_date";
  activityChangeType["ChangedLocation"] = "changed_lbs_location";
  activityChangeType["ChangedLocationDescription"] = "changed_location_description";
  activityChangeType["ChangedBody"] = "changed_body";
  activityChangeType["ChangedRootCause"] = "changed_root_cause_id";
  activityChangeType["ChangedCustomAttributes"] = "changed_custom_attributes";
  activityChangeType["ChangedReference"] = "changed_link";
  activityChangeType["ChangedWatchers"] = "changed_watchers";
  activityChangeType["Placement"] = "placement";
  activityChangeType["ChangedLinkedDocument"] = "changed_target_urn";
  activityChangeType["IssueDeleted"] = "quality-issue-deleted";
  activityChangeType["IssueRestored"] = "quality-issue-restored";
  activityChangeType["ChangedSnapshot"] = "changed_snapshot";
  activityChangeType["Attachment"] = "attachment";
  return activityChangeType;
}({});
const activityChangeTypes = exports.activityChangeTypes = [activityChangeType.ChangedTitle, activityChangeType.ChangedPublished, activityChangeType.ChangedStatus, activityChangeType.ChangedIssueType, activityChangeType.ChangedIssueSubtype, activityChangeType.ChangedDescription, activityChangeType.ChangedAssignedTo, activityChangeType.ChangedStartDate, activityChangeType.ChangedDueDate, activityChangeType.ChangedLocation, activityChangeType.ChangedLocationDescription, activityChangeType.ChangedBody, activityChangeType.ChangedRootCause, activityChangeType.ChangedCustomAttributes, activityChangeType.ChangedReference, activityChangeType.ChangedWatchers, activityChangeType.Placement, activityChangeType.ChangedLinkedDocument, activityChangeType.IssueDeleted, activityChangeType.IssueRestored, activityChangeType.ChangedSnapshot, activityChangeType.Attachment];
//# sourceMappingURL=ActivityLog.js.map